import styled from 'styled-components';

export const Conteiner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;

  width: 100%;
  height: 100%;
  padding: 20px;

  background-color: rgba(0, 0, 0, 0.4);

  z-index: 5;
  overflow: auto;
`;
